import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getCreatedLeadGoogleSources } from "helpers/leads/leadSources";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getAllLeadSourcesTypesAsync = createAsyncThunk(
    "leadSources/getAllLeadSourcesTypes",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/lead/get-source-types`,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getAllLeadSourcesAsync = createAsyncThunk(
    "leadSources/getAllLeadSources",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/lead/sources`,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getSchedules = createAsyncThunk(
    "leadSchedules/getAllLeadSchedules",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/lead/schedules `,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getBaseSource = createAsyncThunk(
    "sourceApi/getBaseSources",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/lead/source-api/types `,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getGoogleConnectedSources = createAsyncThunk(
    "sourceApi/getGoogleConnectedSources",
    async () => {
        let response = await getCreatedLeadGoogleSources();

        if (response.status) {
            return response.data;
        }
        throw Error("Network error.");
    },
);
